<template>
  <div
    class="cms-media-html-editor cms-media-html"
    :class="themeClass"
  >
    <div
      class="editor-contents"
      contenteditable="true"
      v-html="$t(innerValue)"
      @input="$emit('input', $event.target.innerHTML)"
      @keydown="$emit('keydown', $event)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    ></div>
  </div>
</template>
<script>
import useI18n from '@/modules/i18n/mixins/useI18n';
export default {
  name: 'cms-media-html-editor',
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    theme: {
      type: String,
      required: false,
      default: null
    }
  },

  data() {
    return {
      innerValue: ''
    };
  },
  mixins : [useI18n],
  watch: {
    value(newValue) {
      let innerHtml = this.$el.querySelector('.editor-contents').innerHTML;
      if (newValue == innerHtml) {
        return;
      }
      this.innerValue = newValue;
      // v-html deberia hacer esto pero parece estar fallando (!)
      this.$el.querySelector('.editor-contents').innerHTML = newValue;
    }
  },
  computed: {
    themeClass() {
      if (!this.theme) {
        return null;
      }
      return '--theme-' + this.theme;
    }
  },
  mounted() {
    this.innerValue = this.value;
    document.execCommand('defaultParagraphSeparator', false, 'p');
  },
  i18n: {
    "en": {
      "<h1>Title</h1><p>write here</p>": "<h1>Title</h1><p>write here</p>"
    },
    "es": {
      "<h1>Title</h1><p>write here</p>": "<h1>Título</h1><p>escriba aquí</p>"
    },
    "fr": {
      "<h1>Title</h1><p>write here</p>": "<h1>Titre</h1><p>écrivez ici</p>"
    },
    "de": {
      "<h1>Title</h1><p>write here</p>": "<h1>Titel</h1><p>hier schreiben</p>"
    },
    "it": {
      "<h1>Title</h1><p>write here</p>": "<h1>Titolo</h1><p>scrivi qui</p>"
    },
    "pt": {
      "<h1>Title</h1><p>write here</p>": "<h1>Título</h1><p>escreva aqui</p>"
    },
    "gl": {
      "<h1>Title</h1><p>write here</p>": "<h1>Título</h1><p>escriba aquí</p>"
    },
    "ca": {
      "<h1>Title</h1><p>write here</p>": "<h1>Títol</h1><p>escriu aquí</p>"
    },
    "ja": {
      "<h1>Title</h1><p>write here</p>": "<h1>タイトル</h1><p>ここに書いてください</p>"
    }
  }
};
</script>
<style lang="scss">
@import "./themes/index.scss";

.cms-media-html-editor {
  position: relative;

  img {
    max-width: 100% !important;
  }

  [contenteditable] {
    outline: none;
  }
}
</style>